import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import Chip from '@buyside/components/presentation/Chip/chip';

const FilterChip: React.FC<{
  label: string;
  value: string;
  paramName: string;
  paramValue: string;
}> = ({ label, value, paramName, paramValue }): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleRemove = useCallback(() => {
    searchParams.set('page', '1');
    searchParams.delete(paramName, paramValue);
    setSearchParams(searchParams);
  }, [paramName, paramValue, searchParams, setSearchParams]);

  return <Chip label={label} value={value} handleRemove={handleRemove} />;
};

export default FilterChip;
